qw-counter {
  --qw-counter-button-size: 26px;

  display: flex;
  align-items: center;

  border: solid 2px var(--qw-hotel-neutral-medium);
  border-radius: 24px;
  padding: 8px 12px;
}

qw-counter.qw-counter--disabled {
  opacity: var(--qw-hotel-opacity);
  pointer-events: none !important;
}

qw-counter .qw-counter__value {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--qw-counter-button-size);
  height: var(--qw-counter-button-size);
  padding: var(--qw-hotel-gap-sm) var(--qw-hotel-gap-md);
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-m);
}

qw-counter .qw-button {
  width: var(--qw-counter-button-size);
  height: var(--qw-counter-button-size);
  padding-top: 11px;
  padding-bottom: 13px;

  font-size: 20px;
  font-family: var(--qw-hotel-font-family-m);
  background-color: transparent;
  border: 0;
}
